module.exports = {
          srcSet: __webpack_public_path__ + "public/ff74489631fa2b5ee46ab29f9bf9d419-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/ff74489631fa2b5ee46ab29f9bf9d419-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/ff74489631fa2b5ee46ab29f9bf9d419-80.png",
          toString:function(){return __webpack_public_path__ + "public/ff74489631fa2b5ee46ab29f9bf9d419-80.png"},
          
          width: 80,
          height: 80
        }